import { io } from 'socket.io-client';

const URL = process.env.REACT_APP_SOCKET_SERVER_URL || 'ws://localhost:1235';

const getToken = () => {
  return localStorage.getItem('accessToken') || '';
};


// ✅ Configuration SIMPLIFIÉE sans custom path
export const socket = io(URL, {
  // ❌ SUPPRIMER : path: '/websocket/socket.io',
  transports: ['websocket', 'polling'], // ✅ Autoriser les deux au début
  autoConnect: false,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 10,
  auth: (cb) => {
    const token = getToken();
    // if (token) { console.log('Token exists'); }
    cb({ token });
  }
});

socket.on('connect', () => {
  console.log('Socket connected');
});

socket.on('disconnect', (reason) => {
  if (reason === 'io server disconnect') {
    socket.connect();
  }
});

socket.on('connect_error', (error) => {
  console.error('Socket connect error:', error);
});

socket.on('reconnect_attempt', (attemptNumber) => {
  console.log('Socket reconnect attempt:', attemptNumber);
});

socket.on('reconnect', (attemptNumber) => {
  console.log('Socket reconnected:', attemptNumber);
});

export const initializeSocket = () => {
  if (!socket.connected) {
    socket.connect();
  }
};

export const disconnectSocket = () => {
  if (socket.connected) {
    socket.disconnect();
  }
};
